<template>
    <div class="echarts" :id="id">
        <div class="drop-down" v-if='options.dropDownMenu'>
            <div class="drop-down-icon" @click.stop="showPicker">
                <moreImg color="#007AFF" />
            </div>
        </div> 
        <div class="main" ref="main"></div>
    </div>
</template>

<script>
import Gikam from "../../../core/gikam-core";
import picker from "./echartsDropdownPicker";
import Vue from "vue";

export default {
    props: { options: Object, id: [String, Number] },

    mounted() {
        import("echarts").then(echarts => {
            this.echarts = echarts.init(this.$refs.main);
            this.echarts.setOption(this.options);
            this.$emit("ready", this.echarts);
        });
    },

    data() {
        return {
            echarts: null,
            picker : void 0,
            maxHeight : 106,
        };
    },

    methods: {
        cleanPicker() {
            Gikam.dropdownPicker.$destroy();
            Gikam.removeDom(Gikam.dropdownPicker.$el);
            Gikam.dropdownPicker = null;
        },

        showPicker() {
            if (Gikam.dropdownPicker) {
                this.cleanPicker();
                return;
            }
            const $el = this.$el.childNodes[0];
            const $elTop = $el.getBoundingClientRect().top;
            const pickerHeight = this.options.dropDownMenu.lenght * 30 + 16;
            const top = ($elTop + $el.clientHeight + this.maxHeight) > window.innerHeight ? ($elTop - pickerHeight ) : ($elTop + $el.clientHeight + 30);
            const right = document.body.scrollWidth- $el.getBoundingClientRect().right + 18;
            const _this = this;

            Gikam.dropdownPicker = new Vue({
                el: Gikam.createDom('div', document.body),
                provide: {
                    dropdown: this
                },
                methods: {
                    close: _this.cleanPicker
                },
                render() {
                    return (
                        <picker
                            propTop= {top}
                            propRight= {right}
                            propDropDownMenu= {_this.options.dropDownMenu}
                            propHeight= {pickerHeight}
                        />
                    );
                }
            });

            const $picker = Gikam.dropdownPicker.$el;
            $picker.clientHeight > this.maxHeight && ($picker.style.height = this.maxHeight + 'px');
        }
    }
};
</script>

<style scoped>
.echarts,
.main {
    width: 100%;
    height: 100%;
}

.drop-down {
    position: relative;
}

.drop-down > .drop-down-icon {
    padding: 9px 0;
    width: 14px;
    height: 14px;
    cursor: pointer;
    position: absolute;
    right: 18px;
    z-index: 100;
}
</style>